// extracted by mini-css-extract-plugin
module.exports = {"root":"BannerMedium_root__GuxcH","banner":"BannerMedium_banner__QkRZS","imageflex":"BannerMedium_imageflex__d0jYk","content":"BannerMedium_content__1IAmY"};